import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { useHistory } from 'react-router';
import ConnectorDealMoveToButton from './ConnectorDealMoveToButton';
import FancyButton from '../../../components/Button';
import { ConnectorDeal } from '../../../types/types';


const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    padding: '10px 32px'
  }
}));

interface ConnectorDealButtonsBarProps {
  deal: ConnectorDeal
  handleReferralClick?: (deal: ConnectorDeal) => void
}

const ConnectorDealButtonsBar: React.FC<ConnectorDealButtonsBarProps> = ({
  deal, handleReferralClick = undefined
}) => {
  const styles = useStyles();
  const history = useHistory();
  const profileId = deal.entrepreneurProfileId;
  const referralButtonDisabled = !handleReferralClick;

  const onReferClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (!handleReferralClick) { return; }
    handleReferralClick(deal);
  };

  return (
    <div className={styles.root}>
      <Grid container>
        <Grid item container xs={6} justify='flex-start' spacing={2}>
          <Grid item>
            <FancyButton variant='contained' size='small' onClick={() => history.push(`/entrepreneur/${profileId}`)}>
              View Profile
            </FancyButton>
          </Grid>
          <Grid item>
            <ConnectorDealMoveToButton deal={deal} />
          </Grid>
        </Grid>
        <Grid item container xs={6} justify='flex-end'>
          <Grid item>
            <FancyButton
              variant='contained'
              disableElevation
              color='primary'
              size='small'
              onClick={onReferClick}
              disabled={referralButtonDisabled}
            >
              Make referral
            </FancyButton>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ConnectorDealButtonsBar;
